<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="before-the-bombs-ki">
<h1>Before the Bombs: Ki</h1>
<p>Ki moved into the squat and quickly felt at home, she shared a bedroom with Bethany and it was like having the sister she had always wished for. The bungalow only had two bedrooms, so Bethany and Ki had one and the two boys shared the other one.</p>
<p>Ki got a job at the local convenience store, ‘The All-Day – Everyday,’ and they all laughed saying it was very convenient as it was which was quiet literally round the corner.</p>
<p>‘Ha, ha, the old ones are the best,’ laughed Bethany.</p>
<p>For the first time in her life, Ki earned her own money and she felt like she was truly living. For the first time in her life, she finally belonged to a family, a family who cared about her and who she cared about. For the first time in her life, she was happy.</p>
<p>The boys did part-time work wherever they could get it, usually cash in hand and Bethany managed to get a full-time job in a café.</p>
<p>All in all, everything had come together nicely, they had a lovely bungalow, they had money coming in and no bills and they had each other. Life was good.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?6580af9c